<template>
  <v-app dark>
    <!-- Cocuou {{username}}
    <v-btn icon @click="logout"><v-icon>mdi-logout</v-icon></v-btn> -->
    <v-toolbar elevation="3" >
      <v-img :src="images.logo" max-width="140" @click="routeTo('#section-hero-hears', '/')"></v-img>
      <span class="title ml-3 mr-5 primary--text">User&nbsp;/<span class="font-weight-light"> {{username}}</span></span>
      <v-btn icon @click="logout"><v-icon>mdi-logout</v-icon></v-btn>

      <v-spacer></v-spacer>
    </v-toolbar>
    <v-main>
      <v-container fluid pa-0>
        <router-view></router-view>
      </v-container>
    </v-main>
    <public-app-layout-footer></public-app-layout-footer>
  </v-app>
</template>

<script>
import PublicAppLayoutFooter from '@/components/layouts/PublicAppLayoutFooter';

export default {
  name: 'PrivateAppLayout',
  components: {
    PublicAppLayoutFooter
  },
  data: () => ({
    username: '',
    images: {
      // logo: require('@/assets/img/logo-patrowl-dark.png'),
      logo: require('@/assets/img/logo-patrowl-black.png'),
    },
  }),
  mounted() {
    this.getUsername();
  },
  methods: {
    logout() {
      this.$store.commit("removeToken");
      localStorage.removeItem('authToken');
      localStorage.removeItem('username');
      localStorage.removeItem('user_id');
      this.$session.destroy();
      this.$router.push('/login');
    },
    getUsername() {
      this.username = localStorage.getItem('username');
    },
    routeTo(hometo, to) {
      if (this.$route.path == "/") {
        this.$vuetify.goTo(hometo);
      } else {
        this.$router.push(to);
      }
    },
  },
}
</script>
